import { FormSubmissionResult } from '../components/hooks/useFormSubmission';
import { serverUrl } from '../config';
import { DraftData } from './Drafts';

const interpretFormSubmission = <Data>(data: any): FormSubmissionResult<Data> => {
  if (data.errors) {
    return { type: 'validation-error', errors: data.humanized };
  } else if (data.status === 'error') {
    return { type: 'error', error: data.error };
  } else if (data.type === 'exception') {
    throw new Error(data.class);
  } else {
    // TODO: Take an optional decoder here.
    return { type: 'success', data: data };
  }
};

type TempContact = { name: string; email?: string };

/** Fetch new or existing invitational draft */
export const fetchInvitationDraft =
  (token: string) =>
  (contact: TempContact): Promise<FormSubmissionResult<DraftData>> =>
    fetch(`${serverUrl}/api/letters/find-or-create/draft-invitation`, {
      method: 'put',
      headers: {
        authorization: `Token ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(contact),
    })
      .then((res) => res.json())
      .then(interpretFormSubmission)
      .then((result) => result as FormSubmissionResult<DraftData>);
